/**
 * Smooth Scroll functionality for Rich Text buttons to Product Grid sections
 */
class SmoothScrollToSection {
  constructor() {
    this.init();
  }

  init() {
    // Bind event listeners to scroll buttons
    document.addEventListener('click', this.handleScrollClick.bind(this));
  }

  handleScrollClick(event) {
    // Check if the clicked element has the scroll-to-section class
    if (!event.target.classList.contains('scroll-to-section')) {
      return;
    }

    event.preventDefault();
    
    const targetId = event.target.getAttribute('data-scroll-target');
    
    if (!targetId) {
      console.warn('No scroll target ID specified');
      return;
    }

    const targetElement = document.getElementById(targetId);
    
    if (!targetElement) {
      console.warn(`Target element with ID "${targetId}" not found`);
      return;
    }

    this.smoothScrollTo(targetElement);
  }

  smoothScrollTo(element) {
    const headerHeight = this.getHeaderHeight();
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerHeight - 20; // 20px extra spacing

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });

    // Add a highlight effect to the target section
    this.highlightTarget(element);
  }

  getHeaderHeight() {
    const header = document.querySelector('header, .site-header, .header');
    return header ? header.offsetHeight : 0;
  }

  highlightTarget(element) {
    // Add a temporary highlight class
    element.classList.add('scroll-target-highlight');
    
    // Remove the highlight after animation
    setTimeout(() => {
      element.classList.remove('scroll-target-highlight');
    }, 2000);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new SmoothScrollToSection();
  });
} else {
  new SmoothScrollToSection();
}
